import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import CardDealerLocations from '@adv-mt/mt-card-dealer-locations'
import NetSuggestions from '@adv-mt/mt-net-suggestions'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {BASE_CLASS} from './config.js'
import VehicleActions from './vehicleActions.js'
import VehicleComments from './vehicleComments.js'
import VehicleData from './vehicleData.js'
import VehicleEquipment from './vehicleEquipment.js'

const linkFactoryDefaultProp = ({children, ...rest}) => <a {...rest}>{children}</a>

const PanelAdDetails = ({
  ad = {},
  contractId,
  extendedTrackingData = {},
  isFavorite,
  isCanarias = false,
  isPreview = false,
  isSubscription = false,
  linkFactory: Link = linkFactoryDefaultProp,
  middleContent = null,
  onShowModalAdReport = () => {},
  optionalEquipment = [],
  pageName,
  vehicleData = {},
  onOpenNet = () => {}
}) => {
  const {domain} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {SHOW_MULTI_PROVINCE_INFO_ADS} = config.get('search')
  const {NET_SUGGESTION_TYPE} = config.get('COMMON').AI_ASSISTANT
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_ACCESS_CLICKED} = {}} = config.get('tracking') || {}

  const {availableColors} = ad

  const hasVehicleData = Object.keys(vehicleData).length !== 0
  const hasOptionalEquipment = Boolean(optionalEquipment && optionalEquipment.length)

  const hasDescription = Boolean(ad.description)

  const hasMpLocations = Boolean(ad.location) && ad.location.provinceIds.length > 1

  const showLocationsSection = SHOW_MULTI_PROVINCE_INFO_ADS && ad.isProfessional && hasMpLocations

  const trackingData = Link()?.props?.state

  const onClickNetOption = params => {
    track({event: NET_ASSISTANT_ACCESS_CLICKED, data: {hit_origin: pageName}})
    onOpenNet(params)
  }

  return (
    <div className={BASE_CLASS}>
      <PanelBasic>
        <VehicleActions
          ad={ad}
          extendedTrackingData={extendedTrackingData}
          contractId={contractId}
          trackingData={trackingData}
          isFavorite={isFavorite}
          onShowModalAdReport={onShowModalAdReport}
        />
        {hasVehicleData && (
          <VehicleData
            vehicleData={{availableColors, ...vehicleData}}
            isSubscription={isSubscription}
            pageName={pageName}
          />
        )}
      </PanelBasic>

      {middleContent}
      {!isPreview && (
        <NetSuggestions
          showHeader
          isPanel
          adId={ad.id}
          page={NET_SUGGESTION_TYPE.AD_DETAIL}
          onClickOption={onClickNetOption}
        />
      )}

      {showLocationsSection ? (
        <PanelBasic>
          <div className={`${BASE_CLASS}-location`}>
            <CardDealerLocations isCanarias={isCanarias} locations={ad.location} pageName={pageName} />
          </div>
        </PanelBasic>
      ) : null}
      {hasDescription || hasOptionalEquipment ? (
        <PanelBasic>
          {hasDescription && <VehicleComments ad={ad} />}
          {hasOptionalEquipment && <VehicleEquipment optionalEquipment={optionalEquipment} />}
        </PanelBasic>
      ) : null}
    </div>
  )
}

PanelAdDetails.propTypes = {
  ad: PropTypes.object,
  contractId: PropTypes.number,
  extendedTrackingData: PropTypes.object,
  isFavorite: PropTypes.bool,
  isCanarias: PropTypes.bool,
  isPreview: PropTypes.bool,
  isSubscription: PropTypes.bool,
  linkFactory: PropTypes.func,
  middleContent: PropTypes.node,
  onShowModalAdReport: PropTypes.func,
  optionalEquipment: PropTypes.arrayOf(String),
  pageName: PropTypes.string,
  vehicleData: PropTypes.object,
  onOpenNet: PropTypes.func
}

PanelAdDetails.displayName = 'PanelAdDetails'
export default PanelAdDetails
